function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import ChangeHighlightedImmutableUnderReviewControl from '@rd-web-markets/shared/dist/util/reviewEditControls/ChangeHighlightedImmutableUnderReviewControl';
import React from 'react';
import { Form } from 'react-bootstrap';
export const InputCell = _ref => {
  let {
    cellType,
    claim,
    editableObject,
    fieldName,
    disabled,
    userUnauthorizedToEdit,
    onChange = () => {},
    onBlur = () => {},
    refreshClaim,
    ...props
  } = _ref;
  const AsComponents = {
    text: Form.Control,
    number: FormattedNumberInput
  };
  const AsComponent = AsComponents[cellType];
  return /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, _extends({
    as: AsComponent,
    onChange: onChange,
    onBlur: onBlur,
    object: {
      ...editableObject,
      claim: {
        ...claim
      }
    },
    disabled: claim.financials_locked || userUnauthorizedToEdit || disabled,
    name: fieldName,
    type: "text",
    size: "sm",
    autoFocus: true,
    "data-testid": `costfragment-${cellType}-cell`
  }, props));
};
export const CheckBoxCell = _ref2 => {
  let {
    claim,
    editableObject,
    fieldName,
    disabled,
    userUnauthorizedToEdit,
    onChange = () => {},
    onBlur = () => {}
  } = _ref2;
  return /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: Form.Check,
    object: {
      ...editableObject,
      claim: {
        ...claim
      }
    },
    disabled: claim.financials_locked || userUnauthorizedToEdit || disabled,
    name: fieldName,
    onChange: async e => {
      await onChange(e);
      onBlur();
    },
    "data-testid": "costfragment-checkbox-cell"
  });
};